export default class Issue {

    /**
     * Field that this issue correlates to.
     * @var Field
     */
    field = null

    constructor(field) {
        this.field = field
    }

    getWarning() {
        return this.field.warning
    }

    getStep() {
        return this.field.getStep()
    }

}